import script from "./comparePart.vue?vue&type=script&setup=true&lang=js"
export * from "./comparePart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__